import React, { Component } from 'react'
import '../styles/Reports.css'
import DropdownWidget from '../widgets/DropdownWidget'
import OrgFooter from '../widgets/OrgFooter'
import ActivityIndicator from '../widgets/ActivityIndicator'
import APIGenericRequest from '../api/APIGenericRequest'
import APIReportRequest from '../api/APIReportRequest'
import APIClusterRequest from '../api/APIClusterRequest'
import AlertMessage from '../widgets/AlertMessage'
import InputTextFilterWidget from '../widgets/InputTextFilterWidget'

class ReportOrganizationML extends Component
{
	constructor(props) {
		super(props)
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			disabled: props.disabled
		}
		this.getOrganizationsBySiteId = this.getOrganizationsBySiteId.bind(this)
		this.handleFooterEvent = this.handleFooterEvent.bind(this)
		this.getServerDateTime = this.getServerDateTime.bind(this)
	}

	getOrganizationsBySiteId(siteId) {
		const ext = APIReportRequest.getOrganizationsBySiteId(this.state.accessToken, siteId)
		ext.then((response) => {
			console.log('getOrganizationsBySiteId', siteId, response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			this.setState({
				data: response.results.data,
				showActivityIndicator: false
			})
		})
	}

	handleFooterEvent(e) {
		if(this.state.data == null) {
			this.setState({
				showWarningMessage: true,
				aMessage: "No data for export. Please generate report."
			})
			return;
		}
		const dateObj = new Date()
		const month = dateObj.getMonth() + 1
		const date = month + "-" + dateObj.getDate() + "-" + dateObj.getFullYear()
		switch(this.state.typeId) {
			case 1:
				var filename = "RegisteredFarmersReport-" + date;
				break
			case 2:
				filename = "ClusterMembersReport-" + date;
				break
			case 3:
				filename = "CollectiveMarketingReport-" + date;
				break
			case 4:
				filename = "AEStepsTrackingReport-" + date;
				break
			case 5:
				filename = "SWGMembersReport-" + date;
				break
			case 6:
				filename = "OrganizationsReport-" + date;
		}
		// exportToCSV(this.state.data, filename, this.state.typeId)
		this.getServerDateTime(filename)
	}

	getServerDateTime(filename) {
		const apiReq = APIGenericRequest.getServerDateTime(this.state.accessToken)
		apiReq.then((response) => {
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return;
			}
			const dateTime = new Date(response.results.date_time)
		exportToCSV(
			this.state.data,
			filename,
			this.state.typeId,
			dateTime
		)
	})
	}

	render() {
		const view = <div id="report-site">
			<div className="report-details-left"><FilterReport siteId={this.state.siteId} generate={(v) => {
				console.log('generate -->', v)
				switch(v.typeId) {
					case 1:
						this.getOrganizationsBySiteId(this.state.siteId)
						break
					case 2:
						break
					case 3:
						break
					case 4:
						break
					case 5:
						break
					case 6:
						break
					case 7:
						break
					case 8:
				}
				this.setState({
					typeId: v.typeId,
					subTypeId: v.subTypeId,
					data: null
				})
			}} /></div>
			<div className="report-details-right">
				<ReportContent data={this.state.data} typeId={this.state.typeId}
					subTypeId={this.state.subTypeId}/>
				<div className='reports-footer'>
					<OrgFooter eventHandler={this.handleFooterEvent}
						showSubmit={false}
						showExport={true} />
				</div>
			</div>
			{this.state.showWarningMessage == true && <AlertMessage type="warning" text={this.state.aMessage}
				onClick={() => { this.setState({showWarningMessage: false}) }} />}
			{this.state.showActivityIndicator && <ActivityIndicator showActivityIndicator={this.state.showActivityIndicator} />}
		</div>
		return(view)
	}
}

class FilterReport extends Component
{
	constructor(props) {
		super(props)
		const date = new Date()
		this.state = {
			accessToken: JSON.parse(sessionStorage.getItem("token")),
			siteId: localStorage.getItem("siteId"),
			reportType: "-- SELECT --",
			reportSubType: "-- SELECT --",
			interval: "YEARLY",
			period: date.getFullYear(),
			types: [
				{id: 1, name: "PROFILES"},
				{id: 2, name: "CAPITALIZATION"},
				{id: 3, name: "FINANCIAL TRACKING"},
				{id: 4, name: "SMALL INFRASTRUCTURE SUPPORT"},
				{id: 5, name: "COMMITTEE"}
			],
			type: '-- SELECT --',
			capitalizationSubtypes: [
				{id: 1, name: "SOURCE OF FUNDS"},
				{id: 2, name: "EXTERNAL FUNDS"},
				{id: 3, name: "INTERNAL FUNDS"}
			],
			capitalizationSubtype: 'SOURCE OF FUNDS',
			financialTrackingSubtypes: [
				{id: 4, name: "STRATEGY TRACKING"},
				{id: 5, name: "MECHANISM TRACKING"}
			],
			financialTrackingSubtype: 'STRATEGY TRACKING',
			smallInfraSubtypes: [
				{id: 6, name: "SUPPORT PROVIDED"},
				{id: 7, name: "SUPPORT USAGE"}
			],
			smallInfraSubtype: 'SUPPORT PROVIDED'
		}
		this.getAllClustersBySiteId = this.getAllClustersBySiteId.bind(this)
	}

	componentWillMount() {
		this.getAllClustersBySiteId()
	}

	getAllClustersBySiteId() {
		const clusters = APIClusterRequest.getAllClustersBySiteId(this.state.accessToken, this.state.siteId)
		clusters.then((response) => {
			console.log('getAllClustersBySiteId', response)
			if(response.status === "FAILED") {
				this.setState({showActivityIndicator: false})
				return
			}
			// const rows = {}
			const c = []
			for(const v of response.results.rows) {
				console.log(v)
				// rows[v.cluster_id] = ({id: v.cluster_id, name: v.cluster_name, targetCropId: v.target_crop_id})
				c.push({id: v.cluster_id, name: v.cluster_name})
			}
			// const r = Object.values(rows)

			this.setState({clusters: c})
		})
	}

	render() {
		const view = <div className="filter-report">
			<div>Type of Report:</div>
			<DropdownWidget list={this.state.types} placeholder={this.state.type} onItemSelected={(id, val) => {
				console.log('typeid', id)
				const ss = {typeId: parseInt(id), showTypeMSG: false}
				switch(parseInt(id)) {
					case 1:
						ss['subTypeId'] = 0
						break
					case 2:
						ss['subTypeId'] = 1
						ss['capitalizationSubtype'] = "SOURCE OF FUNDS"
						break
					case 3:
						ss['subTypeId'] = 4
						ss['financialTrackingSubtype'] = "STRATEGY TRACKING"
						break
					case 4:
						ss['subTypeId'] = 6
						ss['smallInfraSubtype'] = "SUPPORT PROVIDED"
				}
				this.setState(ss)
			}} />
			<br />
			{this.state.typeId == 2 && <DropdownWidget list={this.state.capitalizationSubtypes}
				placeholder={this.state.capitalizationSubtype} onItemSelected={(id, val) => {
				console.log(id, val)
				this.setState({
					subTypeId: parseInt(id),
				})
			}} />}
			{this.state.typeId == 3 && <DropdownWidget list={this.state.financialTrackingSubtypes}
				placeholder={this.state.financialTrackingSubtype} onItemSelected={(id, val) => {
				this.setState({
					subTypeId: parseInt(id),
				})
			}} />}
			{this.state.typeId == 4 && <DropdownWidget list={this.state.smallInfraSubtypes}
				placeholder={this.state.smallInfraSubtype} onItemSelected={(id, val) => {
				this.setState({
					subTypeId: parseInt(id),
				})
			}} />}
			{this.state.showTypeMSG && <div style={{color: '#c96f6f'}}>* Select type of report</div>}
			<br /><br />
			<button className="green-two" onClick={(k, v) => {
				if(this.state.typeId == null) {
					this.setState({showTypeMSG: true})
				}
				const filter = {
					typeId: this.state.typeId,
					subTypeId: this.state.subTypeId
				}
				console.log('filter -->', filter)
				this.props.generate(filter)
			}}>GENERATE</button>
			<button className="green-two">CLEAR</button>
		</div>
		return(view)
	}
}

class ReportContent extends Component
{
	constructor(props) {
		super(props)
		const user = JSON.parse(sessionStorage.getItem("user"))
		this.state = {
			region: user.region,
			province: user.province,
			siteName: localStorage.getItem("siteName"),
		}
	}

	componentDidUpdate(prevProps) {
		if(prevProps.data != this.props.data && this.props.data != null) {
			console.log('this.props.typeId', this.props.typeId, this.props.data)
			switch(this.props.typeId) {
				case 1:
					this.setState({rfData: this.props.data})
					break
				case 2:
					break
				case 3:
					if(this.props.subTypeId == 1) {

					}
					break
				case 4:
			}
		}
		console.log(this.props.typeId, this.props.subTypeId)
	}

	render() {
		const view = <div id="report-content-site">
			{this.props.data == null && <div className="rcf-content"></div>}
			{this.props.data != null && <div className="rcf-content">
				<div>
				<table className="rcf-table-one">
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<col style={{width: 'auto'}} />
					<tr>
						<th>REGION</th>
						<th>PROVINCE</th>
						<th>SITE NAME</th>
					</tr>
					<tr>
						<td><div>{this.state.region}</div></td>
						<td><div>{this.state.province}</div></td>
						<td><div>{this.state.siteName}</div></td>
					</tr>
				</table>
				{this.props.typeId == 1 && <Profiles data={this.state.rfData}/>}
				{this.props.subTypeId == 1 && <CapitalizationSourceOfFunds data={this.state.data}/>}
				{this.props.subTypeId == 2 && <CapitalizationExternalFunds data={this.state.data}/>}
				{this.props.subTypeId == 3 && <CapitalizationInternalFunds data={this.state.data}/>}
				{this.props.subTypeId == 4 && <FinancialStrategyTracking data={this.state.data}/>}
				{this.props.subTypeId == 5 && <FinancialMechanismTracking data={this.state.data}/>}
				{this.props.typeId == 4 && <SmallInfraSupportProvided data={this.state.data}/>}
				{/* {this.props.subTypeId == 7 && <SmallInfraSupportUsage data={this.state.data}/>} */}
				{this.props.typeId == 4 && <Committee data={this.state.data}/>}
			</div>
			</div>}
		</div>
		return(view)
	}
}

const Profiles = (props) => {
	console.log('Profiles', props)
	const items = []
	if(props.data != null) {
		props.data.map((item, i) => {
			items.push(<ProfileItem data={item} key={Math.random()}/>)
		})
	}
	return(<table className="rcf-table-two">
		<tr><th colspan='12'>ORGANIZATIONS</th></tr>
		<tr>
			<th className='shaded'>DATE ORGANIZED</th>
			<th className='shaded'>NAME</th>
			<th>ORGANIZATION ID</th>
			<th>PARTNERSHIP TYPE</th>
			<th>ARBO TYPE</th>
			<th>ASSETS</th>
			<th>LIABILITIES</th>
			<th>NAME OF AGRARIAN REFORM COMMUNITY</th>
			<th>REGISTERING AGENCY</th>
			<th>DATE REGISTERED</th>
			<th>BOD CHAIR NAME</th>
			<th>BOD CONTACT NUMBER</th>

		</tr>
		{items}
	</table>)
}

const ProfileItem = (props) => {
	return(<tr>
		<td className='shaded'><div>{formatDate(props.data?.date_organized)}</div></td>
		<td className='shaded'><div>{props.data?.name.toUpperCase()}</div></td>
		<td><div>{props.data?.organization_id}</div></td>
		<td><div>{props.data?.partnership_type}</div></td>
		<td><div>{props.data?.arbo_type}</div></td>
		<td><div>{formatCurrency(props.data?.assets)}</div></td>
		<td><div>{formatCurrency(props.data?.liabilities)}</div></td>
		<td><div>{props.data?.test}</div></td>
		<td><div>{props.data?.test}</div></td>
		<td><div>{props.data?.test}</div></td>
		<td><div>{props.data?.test}</div></td>
		<td><div>{props.data?.test}</div></td>
	</tr>)
}

const CapitalizationSourceOfFunds = (props) => {
	return(<table className="rcf-table-two">
		<tr><th colspan='5'>ORGANIZATIONS</th></tr>
		<tr>
			<th className='shaded'>DATE ORGANIZED</th>
			<th className='shaded'>NAME</th>
			<th>NO. OF GRANTS</th>
			<th>NO. OF LOANS</th>
			<th>WITH EXTERNAL FUND</th>
		</tr>
		<tr>
			<td className='shaded'><div>{props.data?.test}</div></td>
			<td className='shaded'><div>{props.data?.test}</div></td>
			<td><div>{props.data?.test}</div></td>
			<td><div>{props.data?.test}</div></td>
			<td><div>{props.data?.test}</div></td>
		</tr>
	</table>)
}

const CapitalizationExternalFunds = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='5'>ORGANIZATIONS WITH EXTERNAL FUNDS - GRANT</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>NAME OF SOURCE</th>
				<th>GRANT AMOUNT</th>
				<th>DATE OF RELEASE</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
		<table className="rcf-table-two">
			<tr><th colspan='7'>ORGANIZATIONS WITH EXTERNAL FUNDS - LOAN</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>TYPE OF LOAN</th>
				<th>NAME OF FINANCIAL INSTITUTION</th>
				<th>LOAN AMOUNT (PHP)</th>
				<th>DATE OF RELEASE</th>
				<th>LOAN STATUS</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const CapitalizationInternalFunds = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='6'>ORGANIZATIONS WITH INTERNAL FUNDS</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>CBU / ANUAL DUES</th>
				<th>MEMBERS WITH FULLY PAID CBU</th>
				<th>SAVINGS</th>
				<th>MEMBERS WITH SAVINGS</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const FinancialStrategyTracking = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='6'>FINANCIN STRATEGY TRACKING</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>DATE</th>
				<th>LINKER</th>
				<th>CONDUIT</th>
				<th>SERVICE PROVIDER</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const FinancialMechanismTracking = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='3'>FINANCING MECHANISM TRACKING</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>NO. OF FINANCIAL MECHANISM</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const SmallInfraSupportProvided = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='4'>SMALL INFRASTRUCTURE SUPPORT</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>NO. OF SUPPORT PROVIDED</th>
				<th>NO. OF SUPPORT USAGE</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const SmallInfraSupportUSAGE = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='4'>SMALL INFRASTRUCTURE SUPPORT</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>NO. OF SUPPORT PROVIDED</th>
				<th>NO. OF SUPPORT USAGE</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const Committee = (props) => {
	return(<div>
		<table className="rcf-table-two">
			<tr><th colspan='3'>AGRO ENTERPRISE COMMITTEE</th></tr>
			<tr>
				<th className='shaded'>DATE ORGANIZED</th>
				<th className='shaded'>NAME</th>
				<th>NO. OF MEMBERS</th>
			</tr>
			<tr>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td className='shaded'><div>{props.data?.test}</div></td>
				<td><div>{props.data?.test}</div></td>
			</tr>
		</table>
	</div>)
}

const getYears = () => {
	const years = []
	const date = new Date()
	console.log(date.getFullYear())
	for(let i=date.getFullYear(); i>1970; i--) {
		years.push({id: i, name: i})
	}
	console.log(years)
	return years
}

const formatDate = (v) => {
	const dt = new Date(v)
	const d = (dt.getDate().toString().length == 1)? `0${dt.getDate()}`: dt.getDate()
	const m = (`${dt.getMonth()+1}`.length == 1)? `0${dt.getMonth()+1}`: dt.getMonth()+1
	const dFormat = `${m}/${d}/${dt.getFullYear()}`
	return dFormat
}

const formatCurrency = (value) => {
	const v = `${value}`
	const c = v.replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,")
	return(c)
}

const exportToCSV = (csvData, filename, typeId, dateTime) => {
	console.log(csvData, filename, typeId)
	const dateObj = new Date()
	const month = dateObj.getMonth() + 1
	const dt = dateObj.getDate() - 1
	const date = month + "/" + dt + "/" + dateObj.getFullYear()
	const data = []
	data.push(["REGION","PROVINCE","MUNICIPALITY"])
	data.push([csvData.region.replace(/\s+/g, '%20'),csvData.province.replace(/\s+/g, '%20'),csvData.city.replace(/\s+/g, '%20')])
	data.push([])
	switch(typeId) {
		case 1:
			data.push(["REGISTERED%20FARMERS"])
			data.push([,"ARBs",,,"NON-ARBs"])
			data.push(["SITE%20NAME","MALE","FEMALE","TOTAL","MALE","FEMALE","TOTAL","Rural%20women%20under%20special%20circumstances%20(ARB%20and%20Non-ARB)","TOTAL"])
			data.push([csvData.site.replace(/\s+/g, '%20'),csvData.arb_male,csvData.arb_female,csvData.total_arb,csvData.non_arb_male,csvData.non_arb_female,csvData.total_non_arb,csvData.rural_women_with_circumstance,csvData.total_registered])
			break
		case 2:
			break
		case 3:
			break
		case 4:
			break
		case 5:
			break
		case 6:
	}
	data.push([])
	data.push(['Date%20Generated: ', `${dateTime.toDateString()} ${dateTime.toLocaleTimeString()}`.replace(/\s+/g, '%20')])
	var csvRow = [];
	for(const v of data) {
		csvRow.push(v.join(","));
	}
	var csvString = csvRow.join("%0A");
	var a = document.createElement('a');
	a.href = 'data:attachment/csv,' + csvString;
	a.target = "_Blank";
	a.download = filename + ".csv";
	a.click();
}

export default ReportOrganizationML
